<div class="title">{{ current }}</div>
<div class="crumbs" style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
  <a [routerLink]="['/']" class="crumb home">Home</a>
  <div *ngFor="let crumb of crumbs" class="crumb" style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
    <mat-icon class="chevron">chevron_right</mat-icon>
    <div class="link">{{ crumb }}</div>
  </div>
  <div class="crumb current" style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
    <mat-icon class="chevron">chevron_right</mat-icon>
    <div class="link">{{ current }}</div>
  </div>
</div>
